import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationSchemeEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-scheme-edit',
	path: '/secure/admin/EditNotificationScheme([!%]?[\\w]*).jspa',
};
